export var FetchStatus;
(function (FetchStatus) {
    FetchStatus["Idle"] = "idle";
    FetchStatus["Fetching"] = "fetching";
    FetchStatus["Success"] = "success";
    FetchStatus["Error"] = "error";
})(FetchStatus || (FetchStatus = {}));
